import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const DefaultLoader = ({ message = "Loading..." }) => {
  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white/90 backdrop-blur-sm transition-opacity duration-300">
      
      {/* Lottie Animation Container */}
      <div className="w-64 h-64 md:w-80 md:h-80 flex items-center justify-center">
        <DotLottieReact
          src="/animations/animation.lottie"
          loop
          autoplay
          className="w-full h-full"
        />
      </div>

      {/* Dynamic Loading Message */}
      {message && (
        <p className="mt-2 text-lg font-medium text-teal-700 animate-pulse tracking-wide">
          {message}
        </p>
      )}
      
    </div>
  );
};

export default DefaultLoader;